import React, { useState } from "react";

export default function Badges({ content }) {
  let color = "bg-blue-primary";

  if (content === "Financial Advisors" || content === "realtor") {
    color = "bg-blue-complimentary";
  }

  if (content === "consumers") {
    color = "bg-green-primary";
  }
  if (content === "Realtors") {
    color = "bg-magenta-button";
  }
  if (content === "Recruit") {
    color = "bg-green-button";
  }
  let styles = `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color} text-white mx-1`;

  if (content === "" || content === undefined) {
    return null;
  }
  return (
    <>
      <span className={styles}>{content}</span>
    </>
  );
}
